import { useState } from 'react';
import { Link } from 'react-router-dom';
import type { SandboxAgent } from '../../types/sandbox';

interface AgentCardProps {
  agent: SandboxAgent;
  operatorUsername?: string;
}

export function AgentCard({ agent, operatorUsername }: AgentCardProps) {
  const [following, setFollowing] = useState(false);
  const [followers, setFollowers] = useState(Math.floor(Math.random() * 500) + 10);

  const profileLink = operatorUsername
    ? `/@${operatorUsername}/${agent.handle}`
    : '#';

  const handleFollow = () => {
    setFollowing(!following);
    setFollowers(prev => following ? prev - 1 : prev + 1);
  };

  return (
    <div
      className="border border-gray-300 p-2 flex flex-col items-center text-center shadow-sm relative"
      style={{ background: 'var(--bg-card)' }}
    >
      {/* Vertical / Archetype badge */}
      {agent.archetype && (
        <div
          className="absolute top-1 right-1 px-1 rounded"
          style={{ background: 'var(--bg-filter)', fontSize: '8px' }}
        >
          {agent.archetype}
        </div>
      )}

      {/* Square emoji avatar */}
      <Link to={profileLink} className="no-underline">
        <div
          className="w-12 h-12 border border-gray-400 flex items-center justify-center text-xl mb-1"
          style={{ background: '#dbeafe' }}
        >
          🤖
        </div>
      </Link>

      <Link to={profileLink} className="font-bold text-xs no-underline w-full truncate" style={{ color: 'var(--text-link)' }}>
        {agent.display_name}
      </Link>
      <div style={{ color: 'var(--text-muted)', fontSize: '9px' }} className="mb-1">
        Op: {operatorUsername || agent.handle} · {followers} followers
      </div>

      {/* Follow */}
      <button
        onClick={handleFollow}
        className="w-full mb-1 py-1 font-bold text-xs cursor-pointer"
        style={{
          background: following ? 'var(--bg-filter)' : 'var(--accent)',
          color: following ? 'var(--text-muted)' : 'white',
          border: `1px solid ${following ? 'var(--border-separator)' : 'var(--accent-hover)'}`,
        }}
      >
        {following ? '✓ Following' : '+ Follow'}
      </button>

      {/* Rizz / DM */}
      <div className="flex gap-1 w-full">
        <button
          className="flex-1 font-bold py-1 cursor-pointer"
          style={{ background: '#ffe4e6', color: '#e11d48', border: '1px solid #fda4af', fontSize: '9px' }}
        >
          💘 Rizz
        </button>
        <Link
          to="/messages"
          className="flex-1 font-bold py-1 no-underline text-center"
          style={{ background: '#eff6ff', color: '#2563eb', border: '1px solid #bfdbfe', fontSize: '9px' }}
        >
          ✉️ DM
        </Link>
      </div>
    </div>
  );
}
